export const tiposCompania = [
  'Cooperativa',
  'Banco',
  'Financiera',
  'Prestamista',
  'Otro',
];

export const monedas = [
  { value: 'DOP', label: 'Peso Dominicano (DOP)' },
  { value: 'USD', label: 'Dólar Estadounidense (USD)' },
  { value: 'EUR', label: 'Euro (EUR)' },
];

export const paises = [
  { value: 'DO', label: 'República Dominicana' },
  { value: 'US', label: 'Estados Unidos' },
  { value: 'MX', label: 'México' },
  { value: 'CO', label: 'Colombia' },
  { value: 'AR', label: 'Argentina' },
  { value: 'CL', label: 'Chile' },
  { value: 'PE', label: 'Perú' },
];

export const rolesUsuarios = [
  { name: 'Administrador' },
  { name: 'Gerente' },
  { name: 'Cajero' },
];

export const listaModulos = [
  {
    categoria: 'Bankivo Assist',
    modulos: [
      { key: 'Chats', label: 'Chats', default: true, companytypes:[]},
      { key: 'Estrategias', label: 'Estrategias', default: true, companytypes:[]},
      { key: 'Metricas', label: 'Metricas', default: true, companytypes:[]},
      { key: 'Comprobantes', label: 'Comprobantes', default: true, companytypes:[]},
    ]
  },

];


export const PREDEFINED_ENDPOINTS = [
  {
    name: 'cliente_details',
    label: 'Detalles de Cliente',
    method: 'GET',
    description: 'Obtiene información detallada de un cliente',
    defaultPath: '/api/clientes/{id}',
  },
  {
    name: 'registrar_pago',
    label: 'Registrar Pago',
    method: 'POST',
    description: 'Registra un pago de préstamo',
    defaultPath: '/api/pagos',
  },
  {
    name: 'obtener_productos_disponibles',
    label: 'Obtener Productos Disponibles',
    method: 'POST',
    description: 'Obtiene los productos disponibles en el inventario.',
    defaultPath: '/api/productos_disponibles',
  },
// Funciones de OpenAI para Function Calling (sin duplicar si ya existen arriba)
{
  name: 'verificar_cliente_actual',
  label: 'Verificar Cliente Actual',
  method: 'POST',
  description: 'Verifica si el cliente ya está verificado en la conversación. Usa esto antes de pedir la cédula.',
  defaultPath: '/api/bankivo-assist/verificar-cliente-actual'
},
{
  name: 'validar_cedula',
  label: 'Validar Cédula',
  method: 'POST',
  description: 'Valida una cédula dominicana de 11 dígitos y verifica si el cliente existe en el sistema.',
  defaultPath: '/api/bankivo-assist/validar-cedula'
},
{
  name: 'obtener_prestamos_cliente',
  label: 'Obtener Préstamos del Cliente',
  method: 'POST',
  description: 'Obtiene la lista de préstamos activos para un cliente según su cédula.',
  defaultPath: '/api/bankivo-assist/prestamos-cliente'
},
{
  name: 'obtener_proxima_cuota',
  label: 'Obtener Próxima Cuota',
  method: 'POST',
  description: 'Obtiene la información de la próxima cuota de un préstamo para un cliente según su cédula.',
  defaultPath: '/api/bankivo-assist/proxima-cuota'
},
{
  name: 'obtener_detalle_prestamo',
  label: 'Obtener Detalle de Préstamo',
  method: 'POST',
  description: 'Obtiene el detalle de un préstamo específico (cuotas, intereses, fechas, etc).',
  defaultPath: '/api/bankivo-assist/detalle-prestamo'
},
{
  name: 'obtener_historial_pagos',
  label: 'Obtener Historial de Pagos',
  method: 'POST',
  description: 'Obtiene el historial de pagos realizados por el cliente.',
  defaultPath: '/api/bankivo-assist/historial-pagos'
},
{
  name: 'obtener_cuentas_bancarias',
  label: 'Obtener Cuentas Bancarias',
  method: 'GET',
  description: 'Obtiene las cuentas bancarias disponibles para realizar pagos. Esta información es pública y no requiere verificación.',
  defaultPath: '/api/bankivo-assist/cuentas-bancarias'
}
];

